import { WindowOrder } from '@cutr/constants/windows/windows';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRevalidator } from 'react-router-dom';

import { keys as windowKeys } from '../order/keys';
import { agentApi } from './api';
import { keys } from './keys';

export const useRefreshOrder = (orderId: string) => {
  const queryClient = useQueryClient();
  const revalidator = useRevalidator();

  return useMutation({
    mutationFn: () => agentApi.refreshOrder(orderId),
    mutationKey: keys.refreshOrder(orderId),
    onSuccess: async (data: WindowOrder, orderId: string) => {
      queryClient.setQueryData<WindowOrder>(windowKeys.getOne(orderId), data);

      revalidator.revalidate();
    },
  });
};

export const useCancelOrder = (orderId: string) => {
  const queryClient = useQueryClient();
  const revalidator = useRevalidator();

  return useMutation({
    mutationFn: () => agentApi.cancelOrder(orderId),
    mutationKey: keys.cancelOrder(orderId),
    onSuccess: async (data: WindowOrder) => {
      queryClient.setQueryData<WindowOrder>(windowKeys.getOne(orderId), data);
      revalidator.revalidate();
    },
  });
};

export const useSendQuote = (orderId: string) => {
  const queryClient = useQueryClient();
  const revalidator = useRevalidator();

  return useMutation({
    mutationFn: () => agentApi.sendQuote(orderId),
    mutationKey: keys.sendQuote(orderId),
    onSuccess: async (data: WindowOrder) => {
      queryClient.setQueryData<WindowOrder>(windowKeys.getOne(orderId), data);

      revalidator.revalidate();
    },
  });
};
